<template>
  <a-modal v-model:visible="visible" title="提示" :width="417">
    <div class="text-center text-sm">
      是否保存对 {{ watchfaceStore.name ?? '-' }} 的修改？
    </div>

    <template #footer>
      <a-button key="back" @click="() => onClick(false)">否</a-button>
      <a-button
        type="primary"
        :loading="watchfaceSaving"
        @click="() => onClick(true)"
      >
        是
      </a-button>
    </template>
  </a-modal>
</template>

<script lang="ts" setup>
import { useWatchfaceSave } from '@/hooks';
import { ElectronApi } from '@/services/electron.api';
import { useWatchfaceStore } from '@/store/use-watchface-store';
import { ref } from 'vue';
import { useRouter } from 'vue-router';

const { saveWatchfaceData, watchfaceSaving } = useWatchfaceSave();
const watchfaceStore = useWatchfaceStore();
const router = useRouter();
const visible = ref(false);
const type = ref<'back' | 'close'>('back');
defineExpose({
  open: (_type: 'back' | 'close' = 'back') => {
    type.value = _type;
    visible.value = true;
  }
});
const onClick = async (save = true) => {
  if (save) {
    await saveWatchfaceData();
  }
  if (type.value == 'close') {
    ElectronApi.close();
  } else {
    router.push('home');
  }
  visible.value = false;
};
</script>
